import { useQuery } from '@tanstack/react-query';
import { useLocation } from '@/shared/hooks/useLocation';
import { setupApi } from '../api/setupApi';
import { setupKeys } from '../queryKeys';

export function useSetupReadiness() {
  const { currentLocation } = useLocation();
  const locationId = currentLocation?.id ?? '';

  const query = useQuery({
    queryKey: setupKeys.readiness(locationId),
    queryFn: () => setupApi.getReadiness(locationId),
    enabled: !!locationId,
  });

  return { ...query, readiness: query.data ?? null };
}
